class SearchForm {
  constructor(el) {
    this.el = el;
    this.isOpen = false;
    
    this.bindUI();
    this.bindEvents();
    this.init();
  }

  bindUI() {
    this.searchToggle = this.el.querySelector('.js-search-toggle');
    this.searchPopup = this.el.querySelector('.js-search-popup');
    this.searchInput = this.searchPopup?.querySelector('input[type="search"]');
    this.searchCloseButton = this.searchPopup?.querySelector('.js-search-close-button');
  }

  bindEvents() {
    if (!this.searchToggle || !this.searchPopup) return;
    
    this.searchToggle.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleSearch();
    });

    this.searchCloseButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeSearch();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.closeSearch();
      }
    });

    document.addEventListener('click', (e) => {
      if (this.isOpen && !this.searchPopup.contains(e.target) && !this.searchToggle.contains(e.target)) {
        this.closeSearch();
      }
    });
  }

  init() {
    if (!this.searchPopup) return;
    
    this.searchTimeline = gsap.timeline({
      paused: true,
      onStart: () => {
        this.searchInput?.focus();
      }
    });
    
    this.searchTimeline.from(this.searchPopup, {
      y: '-100%',
      duration: 0.5,
      ease: 'power2.inOut'
    });
  }

  toggleSearch() {
    this.isOpen ? this.closeSearch() : this.openSearch();
  }

  openSearch() {
    this.isOpen = true;
    this.searchToggle.setAttribute('aria-expanded', 'true');
    this.searchPopup.setAttribute('aria-hidden', 'false');
    this.searchTimeline.play();
  }

  closeSearch() {
    this.isOpen = false;
    this.searchTimeline.reverse();
    this.searchToggle.setAttribute('aria-expanded', 'false');
    this.searchPopup.setAttribute('aria-hidden', 'true');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-search-form').forEach(el => {
    new SearchForm(el);
  });
});
